import { ReactComponent as IcBtn } from 'assets/icons/ic-btn-tukar-uang-usaha.svg'
import CustomButton from 'components/Buttons/CustomButton'
import ModalLandPlot from 'features/private-views/farmers-web/detail/ModalLandPlot'
import { useState } from 'react'
import { ArrowRight, FolderMinus } from 'react-feather'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Card, CardText, UncontrolledTooltip } from 'reactstrap'
import { formatDateOnlyPMB } from 'utils/formatDate'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import { URL_DETAIL_TRANSACTION, URL_TRANSFER_INVENTORY } from 'utils/pathUrl'

export default function DetailModal({
  selectedStock,
  onSetGroup,
  onMoveOutGroup,
  onMovePack,
  status,
}) {
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const toggleModal = () => setIsModalOpen(!isModalOpen)
  const { ownerData } = useSelector((s) => s.dashboard)
  const lotCodes =
    selectedStock?.lots?.length > 0
      ? selectedStock.lots
          .filter((e) => e?.data?.creatorUserId === ownerData?.userId)
          .map((e) => e?.data?.lotCode)
          .filter(Boolean)
      : []

  return (
    <>
      <ModalLandPlot
        row={selectedStock?.landplotting}
        isOpen={isModalOpen}
        toggle={toggleModal}
      />
      <div>
        <Card className="basic-card border-0 shadow-sm">
          <CardText className="no-padding fw-semibold">Kode inventori</CardText>
          <CardText>{selectedStock?.ownerCode ?? '-'}</CardText>
        </Card>
        <Card className="basic-card border-0 shadow-sm">
          <CardText className="no-padding fw-semibold">Lot ID</CardText>
          <CardText>
            <div className="d-flex align-items-center">
              {lotCodes.length > 0 ? lotCodes.join(', ') : '-'}
            </div>
          </CardText>
        </Card>
        <Card className="basic-card border-0 shadow-sm">
          <CardText className="no-padding fw-semibold">Project</CardText>
          <CardText>{selectedStock?.projectName ?? '-'}</CardText>
        </Card>
        <Card className="basic-card border-0 shadow-sm">
          <CardText className="no-padding fw-semibold">Pemanen</CardText>
          <CardText>{selectedStock?.creator?.name ?? '-'}</CardText>
        </Card>
        <Card className="basic-card border-0 shadow-sm">
          <CardText className="no-padding fw-semibold">Barang</CardText>
          <CardText>{selectedStock?.item?.nameItem ?? '-'}</CardText>
        </Card>
        <Card className="basic-card mt-3 border-0 shadow-sm">
          <CardText className="no-padding fw-semibold">Stok barang</CardText>
          <CardText>
            {newFormatThousandSeparator(selectedStock?.amount)}{' '}
            {selectedStock?.unit || selectedStock?.item?.unit}
          </CardText>
        </Card>
        <Card className="basic-card mt-3 border-0 shadow-sm">
          <CardText className="no-padding fw-semibold">Bundle</CardText>
          <CardText>{selectedStock?.bundle ?? 1}</CardText>
        </Card>
        {selectedStock?.userValue?.unitValue !== 0 &&
          selectedStock?.userValue?.unitValue !== null && (
            <Card className="basic-card mt-3 border-0 shadow-sm">
              <CardText className="no-padding fw-semibold">
                Harga Satuan
              </CardText>
              <CardText>
                Rp
                {newFormatThousandSeparator(
                  selectedStock?.userValue?.unitValue,
                )}
              </CardText>
            </Card>
          )}
        <Card className="basic-card mt-3 border-0 shadow-sm">
          <CardText className="no-padding fw-semibold">Lokasi</CardText>
          {selectedStock?.district ||
          selectedStock?.subDistrict ||
          selectedStock?.city ||
          selectedStock?.province ? (
            <CardText>
              {selectedStock?.district || selectedStock?.subDistrict}
              {selectedStock?.district || selectedStock?.subDistrict ? ',' : ''}
              {selectedStock?.city || selectedStock?.province}
            </CardText>
          ) : (
            <CardText>-</CardText>
          )}
        </Card>
        <Card className="basic-card mt-3 border-0 shadow-sm">
          <CardText className="no-padding fw-semibold">Gudang</CardText>
          <CardText>{selectedStock?.warehouse?.name}</CardText>
        </Card>
        {status === 'VERIFIED' ? (
          <Card
            className="basic-card mt-3 border-0 shadow-sm d-flex"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <CardText className="no-padding fw-semibold">
                Grup inventori
              </CardText>
              <CardText>{selectedStock?.group?.label ?? '-'}</CardText>
            </div>
            <div>
              {selectedStock?.group?.label ? (
                <>
                  <CustomButton
                    className="btn-icon ml-1"
                    size="sm"
                    outline
                    color="danger"
                    id="deleteBtn"
                    onClick={onMoveOutGroup}
                  >
                    <FolderMinus size={14} />
                  </CustomButton>
                  <UncontrolledTooltip placement="bottom" target="deleteBtn">
                    Keluarkan Inventori
                  </UncontrolledTooltip>
                  <CustomButton
                    className="btn-icon ml-1"
                    size="sm"
                    outline
                    id="moveBtn"
                    color="primary"
                    style={{ marginLeft: 10 }}
                    onClick={onMovePack}
                  >
                    <IcBtn width={15} height={15} />
                  </CustomButton>
                  <UncontrolledTooltip placement="bottom" target="moveBtn">
                    Pindahkan
                  </UncontrolledTooltip>
                </>
              ) : (
                <CustomButton
                  onClick={() => {
                    onSetGroup()
                  }}
                  size="sm"
                  color="primary"
                  style={{
                    borderRadius: 8,
                    paddingRight: 18,
                    paddingLeft: 18,
                  }}
                >
                  + Grupkan
                </CustomButton>
              )}
            </div>
          </Card>
        ) : null}

        <Card className="basic-card mt-3 border-0 shadow-sm">
          <CardText className="no-padding fw-semibold">Foto barang</CardText>
          <img
            src={selectedStock?.item?.linkFoto}
            style={{
              width: 60,
              height: 60,
              marginBottom: 5,
              paddingTop: 5,
              borderRadius: 99,
            }}
          />
        </Card>
        <Card className="basic-card mt-3 border-0 shadow-sm">
          <CardText className="no-padding fw-semibold">
            Tanggal pembuatan barang
          </CardText>
          <CardText className="fw-semibold">
            {formatDateOnlyPMB(selectedStock?.createdAt)}
          </CardText>
        </Card>
        <Card className="basic-card mt-3 border-0 shadow-sm">
          <CardText className="no-padding fw-semibold">
            Catatan tambahan
          </CardText>
          <CardText className="fw-semibold">
            {selectedStock?.description ? selectedStock?.description : '-'}
          </CardText>
        </Card>
        {(selectedStock?.source?.escrowpaymentId ||
          selectedStock?.source?.warehousetransferId) && (
          <div>
            <Card className="border-0 shadow-sm mt-3 basic-card">
              <span className="fw-600">
                {selectedStock?.source?.escrowpaymentId
                  ? 'Referensi Transaksi'
                  : 'Referensi Transfer Inventori'}
              </span>
              <span
                className="text-primary pointer"
                onClick={() => {
                  navigate(
                    `${selectedStock?.source?.escrowpaymentId ? URL_DETAIL_TRANSACTION : URL_TRANSFER_INVENTORY}/${selectedStock?.source?.escrowpaymentId ? selectedStock?.source?.escrowpaymentId : selectedStock?.source?.warehousetransferId}?type=${selectedStock?.source?.escrowpaymentId ? 'BUY' : 'in'}`,
                  )
                }}
              >
                {selectedStock?.source?.escrowpaymentId
                  ? selectedStock?.source?.poNumber
                  : `TF/ID${selectedStock?.source?.warehousetransferId}`}
              </span>
            </Card>
          </div>
        )}
        {selectedStock?.landplotting && (
          <Card className="basic-card border-0 shadow-sm">
            <CardText className="no-padding fw-semibold">Lahan</CardText>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex flex-column">
                <span className="text-primary fw-semibold">
                  {selectedStock?.landplotting?.landName
                    ? selectedStock?.landplotting?.landName
                    : '-'}
                </span>
                <span>
                  Milik:{' '}
                  {selectedStock?.landplotting?.verifiedprofile?.name ?? '-'}
                </span>
              </div>

              <div
                onClick={() => {
                  toggleModal()
                }}
                className="fw-semibold"
                style={{ cursor: 'pointer' }}
              >
                Lihat Lahan <ArrowRight />
              </div>
            </div>
          </Card>
        )}
      </div>
    </>
  )
}
